import { connect } from 'react-redux'
import CreateBranch from './CreateBranch'
import * as actions from '../../redux/branches'

const mapStateToProps = (state) => ({
  orgID: state.authentication.orgID
})

export default connect(mapStateToProps, actions)(CreateBranch)
